// extracted by mini-css-extract-plugin
export var alternate = "_redotech-arbiter-lib-badge-redo-badge-colors-alternate";
export var black = "_redotech-arbiter-lib-badge-redo-badge-colors-black";
export var blue = "_redotech-arbiter-lib-badge-redo-badge-colors-blue";
export var blueLight = "_redotech-arbiter-lib-badge-redo-badge-colors-blue-light";
export var brand = "_redotech-arbiter-lib-badge-redo-badge-colors-brand";
export var darkMode = "_redotech-arbiter-lib-badge-redo-badge-colors-dark-mode";
export var error = "_redotech-arbiter-lib-badge-redo-badge-colors-error";
export var gray = "_redotech-arbiter-lib-badge-redo-badge-colors-gray";
export var grayBlue = "_redotech-arbiter-lib-badge-redo-badge-colors-gray-blue";
export var iconWrapper = "_redotech-arbiter-lib-badge-redo-badge-colors-icon-wrapper";
export var inactive = "_redotech-arbiter-lib-badge-redo-badge-colors-inactive";
export var indigo = "_redotech-arbiter-lib-badge-redo-badge-colors-indigo";
export var orange = "_redotech-arbiter-lib-badge-redo-badge-colors-orange";
export var pink = "_redotech-arbiter-lib-badge-redo-badge-colors-pink";
export var primary = "_redotech-arbiter-lib-badge-redo-badge-colors-primary";
export var purple = "_redotech-arbiter-lib-badge-redo-badge-colors-purple";
export var success = "_redotech-arbiter-lib-badge-redo-badge-colors-success";
export var warning = "_redotech-arbiter-lib-badge-redo-badge-colors-warning";
export var white = "_redotech-arbiter-lib-badge-redo-badge-colors-white";
export var whiteSuccess = "_redotech-arbiter-lib-badge-redo-badge-colors-white-success";